import { GridColDef } from "@mui/x-data-grid";

export const algoliaSearchColumns: GridColDef[] = [
  {
    field: "objectId",
    headerName: "ID",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "query",
    headerName: "Query",
    width: 100,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "title",
    headerName: "Title",
    width: 200,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "brandName",
    headerName: "Brand Name",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "supplier",
    headerName: "Supplier",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "category",
    headerName: "Category",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "subCategory",
    headerName: "Sub Category",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "packaging",
    headerName: "Packaging",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "price",
    headerName: "Price",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "targetPrice",
    headerName: "Target Price",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
];
